import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/app/App'
import '@/styles/index.css'

const DEPLOY_RELOAD_KEY = 'kuro-platform:deploy-reload'

// Initialize theme before React mount to avoid FOUC
const saved = localStorage.getItem('kuro-platform:theme')
const theme =
  saved === 'light' || saved === 'dark'
    ? saved
    : window.matchMedia('(prefers-color-scheme: light)').matches
    ? 'light'
    : 'dark'
document.documentElement.setAttribute('data-theme', theme)

window.addEventListener('vite:preloadError', (event) => {
  if (sessionStorage.getItem(DEPLOY_RELOAD_KEY) === '1') return

  event.preventDefault()
  sessionStorage.setItem(DEPLOY_RELOAD_KEY, '1')
  window.location.reload()
})

window.addEventListener('load', () => {
  sessionStorage.removeItem(DEPLOY_RELOAD_KEY)
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
